import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

export const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  // Efek untuk mendeteksi scroll
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Efek untuk menutup menu mobile saat pindah halaman
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/products', label: 'Our Products' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 font-body ${
        isScrolled || isMobileMenuOpen
          ? 'bg-white shadow-lg' // Solid white dengan shadow saat di-scroll atau menu mobile terbuka
          : 'bg-white/90 backdrop-blur-sm' // Efek blur saat di atas
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            {/* --- PERUBAHAN DI SINI ---
              1. Ukuran font dibuat responsif: text-2xl (mobile) & md:text-3xl (desktop).
              2. "Kreatif" sekarang satu ukuran dengan "Marajaki" untuk tampilan
                 yang lebih seimbang dan profesional.
              3. Berat font disesuaikan: 'Marajaki' (bold) dan 'Kreatif' (semibold).
            */}
            <div className="text-2xl md:text-3xl font-heading">
              <span className="font-bold" style={{ color: 'var(--rufous)' }}>
                Marajaki
              </span>
              <span className="font-semibold ml-1" style={{ color: 'var(--army-green)' }}>
                Kreatif
              </span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                // Menggunakan font-heading (Poppins) untuk link nav agar lebih stylish
                className={`text-sm font-semibold font-heading transition-colors duration-200 relative ${
                  location.pathname === link.path
                    ? 'text-[var(--rufous)]'
                    : 'text-stone-700 hover:text-[var(--uc-gold)]'
                }`}
              >
                {link.label}
                {location.pathname === link.path && (
                  <span
                    className="absolute -bottom-2 left-0 w-full h-0.5 rounded-full"
                    style={{ backgroundColor: 'var(--rufous)' }}
                  ></span>
                )}
              </Link>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 rounded-lg hover:bg-neutral-100 transition-colors z-50"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6" style={{ color: 'var(--rufous)' }} />
            ) : (
              <Menu className="w-6 h-6" style={{ color: 'var(--rufous)' }} />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu (Animated) */}
      <div
        className={`md:hidden absolute top-full left-0 right-0 w-full shadow-lg overflow-hidden transition-all duration-300 ease-in-out ${
          isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
        style={{
          // Terapkan backdrop-blur di sini juga agar "keren"
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(8px)',
        }}
      >
        <div className="px-4 py-4 space-y-3">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setIsMobileMenuOpen(false)} // Menutup menu saat link diklik
              className={`block px-4 py-3 rounded-lg text-base font-semibold font-heading transition-colors ${
                location.pathname === link.path
                  ? 'bg-[var(--caramel)] text-[var(--rufous)]'
                  : 'text-stone-700 hover:bg-neutral-100'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
};